import type { Translatable } from "app/pages/sales-intelligence/types";

import { ACTION_PANEL_DROPDOWN_VALUE_ALL } from "../../../constants";
import TopNWithCostDropdownItem from "../TopNWithCostDropdownItem/TopNWithCostDropdownItem";
import type { TopNWithCostDropdownItemDeps } from "../TopNWithCostDropdownItem/types";

export default class AllResultsWithCostDropdownItem extends TopNWithCostDropdownItem {
    constructor(deps: Omit<TopNWithCostDropdownItemDeps, "alias" | "id">) {
        super({ ...deps, alias: ACTION_PANEL_DROPDOWN_VALUE_ALL, id: ACTION_PANEL_DROPDOWN_VALUE_ALL });
    }

    getTranslation(): Readonly<Translatable> {
        return {
            key: `si.${this.translationKeyModifier}.options.all-results`,
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }
}
